module.exports = __webpack_public_path__ + "static/img/03-exernal-tool-find-btn.9bc3cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-assignment-guide/03-exernal-tool-find-btn.png
// module id = +706
// module chunks = 1